<template>
  <section class="app-main">
    <transition name="page-fade">
      <router-view></router-view>
    </transition>
  </section>
</template>

<script>
export default {
  name: 'AppMain'
}
</script>

<style lang="scss" scoped>
.app-main {
  min-height: calc(100vh - 95px);
  width: 100%;
  position: relative;
  overflow: visible;
  padding: 0;
  box-sizing: border-box;
}

/* 轻量级页面切换动画：仅淡入，不阻塞，主观切换更快 */
.page-fade-enter-active {
  transition: opacity 0.12s ease;
}
.page-fade-enter {
  opacity: 0;
}
.page-fade-enter-to {
  opacity: 1;
}
.page-fade-leave-active,
.page-fade-leave-to {
  transition: none;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/AppMain.vue